import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { Observable } from 'rxjs';
import { ContentVm, GetAllTicketTermsAndConditionsVm } from '../models/terms.model';

@Injectable({ providedIn: 'root' })
export class TermsService extends BaseApiService {
  getAllTicketTermsAndConditions(): Observable<GetAllTicketTermsAndConditionsVm> {
    // Mapea /terms-and-conditions/tickets
    return this.get<GetAllTicketTermsAndConditionsVm>('/terms-and-conditions/tickets');
  }

  getTicketTermsAndConditions(ticketTypeCode: string): Observable<ContentVm> {
    // Mapea /terms-and-conditions/tickets/{ticketTypeCode}
    return this.get<ContentVm>(`/terms-and-conditions/tickets/${ticketTypeCode}`);
  }
}
